import { HttpClientModule} from '@angular/common/http';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ToastaModule } from 'ngx-toasta';
import { AppRoutingModule } from './app.routing';
import { HttpService } from './shared/services/http.service';

import { AppComponent } from './app.component';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthGuard } from './guards/auth.guard';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { ModalModule } from 'ngx-bootstrap/modal';
//fontawesome
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { UserService } from './services/user.service';
import { ParameterService } from './services/parameter.service';
import { ApplicationUserService } from './services/application.user.service'
import { AuthService } from './services/auth.service'
import { ChartsModule } from 'ng2-charts';
import { LoginComponent } from './components/login/login.component';

import { GifcardVirtualService } from './services/gifcardVirtual.service';
import { OrderSalesModule } from './components/ordersales-gcv/ordersales.module';
import { ClientsModule } from './components/clients/clients.module';
import { TemplateModule } from './components/template/template.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CaptchaModule } from 'primeng/captcha';
import { ButtonModule } from 'primeng/button';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MomentModule } from 'angular2-moment';
import { DialogModule } from 'primeng/dialog';
import { ModelsModule } from './components/models/models.module';
import { ImageService } from './services/image.service';
import { JobService } from './services/job.service';
import { EmailService } from './services/email.service';
import { CacConsultModule } from './components/cac/cac.module';
import { CacService } from './services/cac.service';
import { ReportModule } from './components/reports/reports.module';
import { ReportService } from './services/report.service';
import { FileService } from './services/file.service';
import { TraceService } from './services/trace.service';
import { OrderSalesFisicaModule } from './components/ordersales-gcf/ordersales.fisica.module';
import { GifcardFisicaService } from './services/giftcardFisica.service';
import { OrderSalesTiendaModule } from './components/ordersales-tv/ordersalestienda.module';
import { GifcardTiendaService } from './services/giftcardTienda.service';

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    HomeComponent,
    UnauthorizedComponent,
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    LoginComponent
  ],

  imports: [
    FormsModule,
    ReactiveFormsModule,    
    BrowserModule,
    BrowserAnimationsModule,
    ToastaModule.forRoot(),
    ModalModule.forRoot(),
    MomentModule,
    NgIdleKeepaliveModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    AngularFontAwesomeModule,
    ChartsModule,
    OrderSalesModule,
    OrderSalesFisicaModule,
    OrderSalesTiendaModule,
    ClientsModule,
    ModelsModule,
    TemplateModule,
    CaptchaModule,
    ButtonModule,
    DialogModule,
    CacConsultModule,
    ReportModule
  ],
  providers: [
    HttpService,
    AuthGuard,
    UserService,
    ParameterService,
    GifcardVirtualService,
    ApplicationUserService,
    AuthService,
    ImageService,
    JobService,
    EmailService,
    CacService,
    ReportService,
    FileService,
    TraceService,
    GifcardFisicaService,
    GifcardTiendaService
  ],
  exports: [
    LayoutComponent,
    ToastaModule    
  ],
  schemas: [NO_ERRORS_SCHEMA],

  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
  ) {
  }

}
